import React, { FC } from 'react';
import { withHeader } from '../../HOC/withHeader';
import { RecognitionPage } from '../../modules/recognition/RecognitionPage';

const Module: FC = () => <RecognitionPage type="youtube" />;

export const YoutubeToTextPageContainer: FC = withHeader(Module);
